import { useGetMcpServersAvailableToPortalQuery } from '../../../../__generated__/chirp/com/hubspot/mcp/server/registry/rpc/McpServerRegistryRpc.hooks';
export const useMcpSupportedApps = args => {
  var _args$skip;
  const {
    data,
    loading,
    error,
    networkStatus
  } = useGetMcpServersAvailableToPortalQuery({
    skip: (_args$skip = args === null || args === void 0 ? void 0 : args.skip) !== null && _args$skip !== void 0 ? _args$skip : false
  });
  return {
    data: (data === null || data === void 0 ? void 0 : data.mcpServers) || [],
    loading,
    error: error || null,
    networkStatus
  };
};